import {useDebugValue} from 'react';

import {DEFAULT_FIELD_AUTO_PROGRESS_TYPE} from '../../../utils/field';

import {useOptions} from './useOptions';

const defaultFormOptions = {
    allowErrorHighlighting: false,
    allowSummary: false,
    autoProgress: DEFAULT_FIELD_AUTO_PROGRESS_TYPE,
    autoSubmit: true,
    layout: 'standard',
    align: 'center',
    showIcons: true,
    showGuestsDetailsInputField: true,
    showSubmitDetailsButtonField: true,
};

function useFormOptions(props) {
    const {
        formOptions: propsFormOptions
    } = props;

    const {
        options: formOptions
    } = useOptions(defaultFormOptions, propsFormOptions);

    const result = {
        formOptions
    };

    useDebugValue(result);

    return result;
}

export {useFormOptions};
